import { render, staticRenderFns } from "./SubscriptionItem.vue?vue&type=template&id=13da146a&"
import script from "./SubscriptionItem.vue?vue&type=script&lang=js&"
export * from "./SubscriptionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports